import lodashGet from "lodash/get";

import { layerClickEventHandlerOff } from "@/common/maps/eventHandler";

export { _addLayer as addLayer };
export { _removeAllDataLayers as removeAllDataLayers };
export { _removeLayer as removeLayer };
export { _setBaseLayer as setBaseLayer };

let layers = {};

const _addLayer = (map, layer, before) => {
  _handleAddLayer(map, layer, before);
  if (map && !layer.hypDisableHover) {
    map.on("mousemove", layer.id, _showCursorPointerOnFeature);
  }
};

const _handleAddLayer = (map, layer, before) => {
  if (map) {
    const INDENTIFIER = _getLayerIdentifier(map, layer.id);
    if (!map.getLayer(layer.id)) {
      if (before && before !== layer.id) {
        map.addLayer(layer, before);
      } else {
        map.addLayer(layer);
      }
    } else {
      if (JSON.stringify(layer) !== JSON.stringify(layers[INDENTIFIER])) {
        for (let property in layer.paint) {
          if (layer.paint.hasOwnProperty(property)) {
            map.setPaintProperty(layer.id, property, layer.paint[property]);
          }
        }
      }
    }
    layers[INDENTIFIER] = layer;
  }
};

const _getLayerIdentifier = (map, layerId) => {
  if (lodashGet(map, "_container.id")) {
    return map._container.id + "-" + layerId;
  }
  return null;
};

const _showCursorPointerOnFeature = (e) => {
  e.target.getCanvas().style.cursor =
    e.features && e.features.length ? "pointer" : "";
};

const _removeAllDataLayers = (map, layerId) => {
  if (map && layerId) {
    _removeLayer(map, layerId);
    _removeLayer(map, layerId + "-marker");
    _removeLayer(map, layerId + "-marker-cluster");
    _removeLayer(map, layerId + "-heatmap");
    _removeLayer(map, layerId + "-geohash");
    _removeLayer(map, layerId + "-geohash-cluster");
    _removeLayer(map, layerId + "-polygon");
  }
};

const _removeLayer = (map, layerId) => {
  map.off("mousemove", layerId, _showCursorPointerOnFeature);
  _handleRemoveLayer(map, layerId);
};

const _handleRemoveLayer = (map, layerId) => {
  const INDENTIFIER = _getLayerIdentifier(map, layerId);
  if (layers[INDENTIFIER] && map.getLayer(layerId)) {
    layerClickEventHandlerOff(map, layerId);
    map.removeLayer(layerId);
  }
  delete layers[INDENTIFIER];
};

const _setBaseLayer = (map, layerSource) => {
  map.setStyle(layerSource);
};
